<template>
  <div class="tab-container" ref="tabContainer">
    <splitpanes horizontal v-if="tab.type === 'query'" @resize="getPos" @resized="onResized">
      <pane>
        <!-- <div class="top-pane" :style="{height: aceHeight+'px',width: aceWidth+'px',position:'relative'}"> -->
        <div class="top-pane" :style="{height: 100+'%',width: 100+'%',position:'relative'}">
          <!-- 
          width:'100%', 
          :theme="theme"
           :height="aceHeight + 'px'"
           <aceeditor
             @init="editorInit" 
             ref="codeEditor" 
             v-model="tab.query"
             lang="sqlserver" 
             theme="sqlserver"           
             :height="100 + '%'"
           >            
         </aceeditor>          
          -->
          <VueAceEditor
            @init="editorInit" 
            ref="codeEditor" 
            v-model="tab.query"
            lang="sqlserver" 
            :height="100 + '%'"
            :theme="editorTheme"
            />
            <!-- theme="sqlserver" -->
        </div>
      </pane>
      <pane ref="botPane" @resize="resizePanel()">
        <div class="bottom-pane" :class="{'darkBtmtheme':state.dark}" id="bottom-pane" ref="bottomPane">
          <!-- <div v-if="tab.error && tab.error.length > 0" class="errordiv"> -->
          <div v-if="state.active_tab && state.active_tab.error && state.active_tab.error.length > 0" class="errordiv">
            <span style="color: red;font-weight: bold;" v-for="(err,index) in state.active_tab.error" :key="index">Error: {{err}}</span>
            <button v-on:click="clearResult()" class="clear">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g id="close">
                  <path id="x" d="M18.717 6.697l-1.414-1.414-5.303 5.303-5.303-5.303-1.414 1.414 5.303 5.303-5.303 5.303 1.414 1.414 5.303-5.303 5.303 5.303 1.414-1.414-5.303-5.303z"/>
                </g>
              </svg>
            </button>
          </div>
          <SingleRequest v-if="tab.resultMulti.length == 1"
                         :tab="state.openedtabs[state.openedtabs.findIndex((el)=> tab.name == el.name)]"
                         :bHeight="botheight"
                         :gWidth="state.gridWidth"
                         :state="state" 
                         :dark="dark"
                         ref="singleRequest" 
                         />
          <multipule 
            v-if="state.active_tab && state.active_tab.resultMulti && state.active_tab.resultMulti.length > 1" 
            :state="state" 
            :bHeight="botHeight"
            :bWidth="state.gridWidth"
            :tabName="tab.name" 
            v-on:clearResult="clearResult()"
            :key="tab.name + 'multi'"
            :dark="dark"
            />
             <!--:gWidth="state.gridWidth"--> 
          <!-- <div class="error" v-if="tab && tab.err != 0">{{tab.msg}}</div> -->
        </div>
      </pane>
    </splitpanes>
    
    <div v-if="tab.type === 'edit-index'">
      <!-- <edit-index-content v-if="tab.table" :state="state" :tab="tab">
      </edit-index-content> -->
      <EditIndexVuetify v-if="tab.table" :state="state" :tab="tab"/>
    </div>
    <div v-if="tab.type === 'edit-table'" style="height:100%; overflow:auto">
      <!-- <edit-table-content :state="state" :db="tab.db" :table="tab.table" :tab="tab">
      </edit-table-content> -->
      <edit-table-vuetify v-if="tab.type === 'edit-table'" :tab="tab" :state="state" style="height:100%; overflow:auto"></edit-table-vuetify>
    </div>
    <div  v-if="tab.type === 'diagram'" style="height:100%;">
      <diagram :db="tab.db" :tab="tab"></diagram>
    </div>
    <Monitoring :height="state.height-48" v-if="tab.type === 'monitoring'"/>
    <div class="statusbar" :class="{'darkStatus':state.dark}">
      <div v-if="state.active_db" class="info-line">
        <span>NBAdmin: {{state.NBAdmin}}, NitrosBase: {{state.version}} {{this.state.trial ? "(trial)" : ""}} </span>
        <span>{{tab.status }} {{tab.result ? `rows: ${tab.result}` : "" }}</span>
      </div> 
    </div>
  </div>
</template>

<script>
import { commonMixin } from '../common.js';
import EditIndexContent from './edit-index-content';
import EditTableContent from './edit-table-content';
import 'vue-select/dist/vue-select.css';
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import multipule from './multipule-request.vue'
import Diagram from './diagram.vue'
import SingleRequest from './single-request.vue'
import grid from './baseComponents/grid.vue'
import EditTableVuetify from "./edit-table-vuetify.vue";
import EditIndexVuetify from "./edit-index-vuetify.vue";
import Monitoring from "./monitor.vue";
import VueAceEditor from 'vue2-ace-editor'
import 'brace/mode/javascript'
import 'brace/theme/chrome' // светлая тема
import 'brace/theme/twilight' // темная тема

export default {
  mixins: [commonMixin],
  components: {
    Splitpanes, 
    Pane,  
    EditIndexContent, 
    EditTableContent, 
    multipule, 
    Diagram,
    SingleRequest,
    grid,
    EditTableVuetify,
    EditIndexVuetify,
    Monitoring,
    VueAceEditor
  },
  data(){
    return {
      editor: null,
      editorint: null,
      botheight: null,
      topheight: null,
      width: null,
      rows: null,
      comment: null,
      componentKey: 0,
    }
  },
  props: {
    tab: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    dark: {
      type: Boolean
    }
  }, 
  watch: {
    'state.gridWidth'() {
      if (this.editor) {        
        this.editor.resize()
      }
    },
    'state.height'() {
      this.getPos()
    },   
    watch: {
  'state.active_tab.error': {
    handler(newVal) {
      console.log('Error array changed:', newVal);
    },
    deep: true
  }
}
  },
  mounted() {
    if (this.tab.resultMulti) {
      window.hostname = {
        idconnect: this.tab.idconnect, 
        query: this.tab.resultMulti.length, 
        fields:[],
        width:this.state.gridWidth,
        baseUrl: this.baseUrl,
      }
    }
    // console.log('querMount',this.$refs.codeEditor.$el.children[0].focus());
    this.topheight = (this.state.height - 48 - 6)/2
    // this.topheight = (this.$refs.tabContainer.clientHeight-6)/2
    this.botheight = (this.state.height - 48 - 6)/2
    // console.log('queryMheight',this.state.height,this.botheight);
    // this.botheight = (this.$refs.tabContainer.clientHeight-6)/2
    this.width = this.$refs.tabContainer.clientWidth
    //if (this.state.active_tab && this.state.active_tab.editor) {
      //this.state.active_tab.editor.focus() 
    //}
  },
  updated() {
  },
  computed: {
    editorTheme() {
      return this.state.dark ? 'twilight': 'sqlserver'
    },
    aceHeight() {
      return this.topheight
    },
    aceWidth() {
      return this.state.gridWidth
    },
    botHeight() {
      console.log('comp quey bh')
      return this.botheight -28
    },
    botWidth() {
      console.log('bw', this.$refs.botPane.$el.clientWidth)
      return this.$refs.botPane.$el.clientWidth
    },
  },
  watch: {
    // state: {
    //   dark: function (params) {
    //     console.log('watch dark');        
    //   },      
    //   deep: true
    // },
  },
  methods: {
    onResized() {
      // Вызывается когда изменение размера завершено      
      if(this.$refs.singleRequest) this.$refs.singleRequest.handleResizeComplete()
    },
    resizePanel() {
      console.log('resizePanel')
    },
    clicComp() {
      console.log('clicComp');
    },
    getComment(comment) {
      this.$emit('sendComment',comment)     
    },
    clearResult() {
      this.tab.resultMulti = []
      this.tab.status = ""
      this.tab.error = []
    },
    columnname(obj) {
      if(obj === '') { 
        return obj = ' '
      }
      return obj
    },
    getPos() {
      // console.log('QgetPos');
      // console.log('QgetPos2',this.$refs.tabContainer.clientHeight);
      this.topheight = this.$refs.tabContainer.clientHeight - this.$refs.bottomPane.clientHeight - 7
      this.botheight =  this.$refs.bottomPane.clientHeight
      this.editorint.resize()
    },
    editorInit(editor) {
      // console.log('ace Init',this.tab.name);
      editor.session.setNewLineMode("unix");
      this.tab.editor = editor;
      require('brace/ext/language_tools') //language extension prerequsite...
      require('brace/mode/sqlserver')
      require('brace/theme/sqlserver')
      editor.setShowPrintMargin(false);
      editor.setHighlightActiveLine(false);
      editor.setOptions({
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: false,
        showLineNumbers: true,
        fontSize: 14,
        fontFamily: 'monospace',
        enableMultiselect: false,
        // theme: "ace/theme/chrome",
      });
      editor.setFontSize(20) 
      // document.getElementById('editor').style.fontSize='12px';
      // setTimeout(editor.resize(),500)
      
      this.editorint = editor
      this.editorint.on("paste", (event)=> {
        // console.log('pastate');
        this.editorint.resize()
        // let arr = event.text.split('\n').map(i=>i.length)
        // let largest = Math.max.apply(Math, arr);
        // let index = arr.find(i => i == largest)
        // console.log('pastate1',arr, index,arr[index]);
        // this.state.active_tab.editor.focus() 
        // editor.session.insert({
        //   row: editor.session.getLength(), // or you can use "pos.row"
        //   column: editor.selection.getCursor().column,
        // }, " " + "abc" + " ");
      })
      this.editorint.commands.addCommand({
        name: 'saveFile',
        bindKey: {
          win: 'Ctrl-S', mac: 'Command-S',
          sender: 'editor|cli'
        },
        exec: (env, args, request)=> {
          this.SaveActiveTab();
        }
      });
      editor.commands.addCommand({
        name: 'execute',
        bindKey: {
          win: 'F5', mac: 'F5',
          sender: 'editor|cli'
        },
        exec: (env, args, request)=> {         
          window.editor = this.tab.editor;
          // console.log('ace', window.hostname.loading);
          if (!window.hostname.loading) {
            this.RunActiveTab();            
          }
        }
      });
      // this.tab.editor = editor;
      // editor.resize()
      /*
      */
      editor.session.on("changeScrollLeft",(e)=> {
        // console.log('scroll',e);
        window.dispatchEvent(new Event('resize')); 
      })
      editor.session.on("DOMContentLoaded",(e)=> {
        console.log('onload',e);
        
      })
    },
    flexInitialized: function(flexgrid) {
      this.flex = flexgrid;
      flexgrid.selectionMode = 'CellRange';
      flexgrid.allowSorting = false;
      this.flexgrid = flexgrid;
    },
    sessinon(e) {  
      console.log('sessinon');   
      this.editorint.resize()
      // const parsed = JSON.stringify(this.tab.query);
      // sessionStorage.setItem(`${this.tab.idconnect}`, parsed)
    }
  },
}
</script>
<style lang="css">
.darkStatus {
  background: rgb(20, 20, 20);
}
.darkBtmtheme {
  background-color: #141414;;
}
.wrap-clear {
  text-align: right;
}
.clear {
  fill: red;
  margin-right: 20px;
  font-weight: bold;
  border: none;
  background: none;
}
.tab-container{
  margin: 0;
  padding: 0;
  height: calc(100% - 28px);
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.panes-separator-H{
  border-top: solid 1px lightgray;
  border-bottom: solid 1px lightgray;
  width: 100%;
  height: 5px;
  cursor: row-resize;
}

  .bottom-pane {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-y: auto;
/*    justify-content: end;*/
    /* align-items: flex-end; */
    /* overflow: hidden; */
  }

#theGrid {
  height: calc(100% - 28px);
}
  .statusbar {
    /* position: fixed; */
    bottom: 0;
    background: transparent;
    /* height:100%; */
    height: 28px;
    color: blueviolet;
/*    padding-bottom: 10px;*/
/*    margin-top: 29%;*/
    width: 100%
  }
.info-line {
  display: flex;
  justify-content: space-between;
  padding-right: 10px;
  width: 100%;
}
.info span:last-child {
  margin-left: 5px;
}
.wj-content{
  border-radius:0!important;
  border: none;
}
.ace-sqlserver .ace_gutter{
  background-color: white!important;
}
.splitpanes.default-theme .splitpanes__pane {
    background-color: white;
}
.default-theme.splitpanes--horizontal>.splitpanes__splitter, .default-theme .splitpanes--horizontal>.splitpanes__splitter {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
}
.ace_gutter{
  bottom: 1px;
}
.errordiv{
  align-items: flex-start;
  display: flex;
  justify-content: space-between
}
.errordiv2{
  padding: 7px 12px;
  height: calc(100% - 28px);
}
.ace-sqlserver, .ace-sqlserver .ace_gutter, .ace-sqlserver .ace_identifier, .ace-sqlserver .ace_constant.ace_numeric{
  color: #777!important;
}
.ace-sqlserver .ace_keyword{
  color: #0085C7!important;
}
.ace_scroller.ace_scroll-left {
  box-shadow: none; 
}
.ace_scrollbar-h {
  left: 0!important;
}
.ace_editor {
  font-size: 14px!important;
}
  .single {
      height: 100%;
  }
</style>
